import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header style={{ boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)' }}>
      <div className="container">
        <nav className="navbar">
          <Link to="/" className="logo" style={{ fontSize: '1.8rem', fontWeight: 800 }}>
            <div className="logo-icon" style={{ width: '2.5rem', height: '2.5rem' }}></div>
            <div>After<span>image</span></div>
          </Link>
          <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <Link to="/mission" style={{ fontSize: '1.1rem', fontWeight: 600 }}>Our Mission</Link>
            <Link to="/impact" style={{ fontSize: '1.1rem', fontWeight: 600 }}>Impact</Link>
            <Link to="/team" style={{ fontSize: '1.1rem', fontWeight: 600 }}>Team</Link>
            <Link to="/careers" style={{ fontSize: '1.1rem', fontWeight: 600 }}>Get Involved</Link>
          </div>
          <button className="mobile-toggle" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? '✕' : '≡'}
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header; 